"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpriteProvider = void 0;
/**
 * @public
 * Creates a hidden 2d canvas, useful for sprites etc.
 */
class SpriteProvider {
    constructor(attachPoint) {
        this.canvasElement = attachPoint.addHiddenElement("axis-labels", "canvas");
        this.context = this.initializeContext();
    }
    upscaleCanvas(width, height) {
        if (height > this.canvasElement.height) {
            height = SpriteProvider.nearestPowerOf2(height);
            this.canvasElement.height = height;
        }
        if (width > this.canvasElement.width) {
            width = SpriteProvider.nearestPowerOf2(width);
            this.canvasElement.width = width;
        }
    }
    getCanvas() {
        return this.canvasElement;
    }
    getContext() {
        return this.context;
    }
    initializeContext() {
        const context = this.canvasElement.getContext("2d");
        if (context == null) {
            throw new Error("failed to initialize axis canvas");
        }
        return context;
    }
    static nearestPowerOf2(value) {
        return 1 << (32 - Math.clz32(value));
    }
}
exports.SpriteProvider = SpriteProvider;
//# sourceMappingURL=sprite-provider.js.map